import {saveAs} from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import logo from '../assets/images/asset1.png'; // Adjust path as needed

export const printPDF = ({title, headers, data, subHeaders, subRow}) => {
  const img = new Image();
  img.src = logo;

  img.onload = () => {
    const doc = new jsPDF();

    const originalWidth = 426;
    const originalHeight = 162;
    const scaleFactor = 0.2;
    const imageWidth = originalWidth * scaleFactor; // 213
    const imageHeight = originalHeight * scaleFactor; // 81

    doc.addImage(img, 'PNG', 10, 10, imageWidth, imageHeight);
    doc.setFontSize(12);
    doc.text('Accumed Speciality Clinic and Scans', 105, 25); // Adjust X (65) and Y (15)
    doc.setFontSize(10);
    doc.text('24, Chowdry Nagar Main Rd, opp. Vasanthi Dental Hospital,', 105, 30); // Adjust X (65) and Y (25)
    doc.text('Majestic Colony, Valasaravakkam, Chennai, Tamil Nadu 600087', 105, 35); // Adjust X (65) and Y (25)
    doc.text('___________________________________________________', 105, 38); // Adjust X (65) and Y (25)
    const date = new Date();
    doc.setFontSize(10);
    const todayDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    doc.text(`Date: ${todayDate}`, 195, 45, {align: 'right'});

    // Build table from object-based rows
    const headerKeys = Object.keys(headers);
    const headerTitles = Object.values(headers);

    const objectRows = data.map(item => {
      const rowObj = {};
      headerKeys.forEach(key => {
        rowObj[key] = item[key] || 'N/A';
      });
      return rowObj;
    });

    const columns = headerKeys.map((key, i) => ({
      header: headerTitles[i],
      dataKey: key
    }));

    // Render main table
    autoTable(doc, {
      startY: 50,
      columns,
      body: objectRows,
      headStyles: {
        fillColor: [230, 230, 230],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        halign: 'center'
      },
      bodyStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        halign: 'center'
      },
      styles: {
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        fontSize: 9,
        cellPadding: 2,
        overflow: 'linebreak'
      }
    });

    // Render footer aligned with main table
    // Map footer data

    // Render footer aligned with main table
    if (subHeaders && subRow) {
      const footerColumns = Object.entries(subHeaders).map(([key, title]) => ({
        header: title,
        dataKey: key
      }));

      const footerData = Object.keys(subHeaders).reduce((acc, key, index) => {
        acc[key] = subRow[index] || '';
        return acc;
      }, {});

      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 10,
        columns: footerColumns,
        body: [footerData],
        headStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          halign: 'center'
        },
        bodyStyles: {
          halign: 'center',
          textColor: [0, 0, 0]
        },
        styles: {
          fontSize: 9,
          cellPadding: 2,
          lineColor: [0, 0, 0],
          lineWidth: 0.1
        }
      });
    }

    window.open(doc.output('bloburl'), '_blank');
  };
};

export const downloadExcel = ({title, headers, data, subRow}) => {
  const formattedData = transformData(data, headers);

  // Extract header display names
  const headerRow = Object.values(headers);
  const body = formattedData.map(item => Object.keys(headers).map(key => item[key]));

  const sheetData = [headerRow, ...body];

  // Add footer if available and it's an array
  if (subRow && Array.isArray(subRow)) {
    sheetData.push([]);
    sheetData.push(subRow);
  }

  const ws = XLSX.utils.aoa_to_sheet(sheetData);

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, title || 'Sheet1');

  const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
  const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});

  saveAs(blob, `${title || 'export'}.xlsx`);
};

const transformData = (data, headers) => {
  return data.map(item => {
    let transformedItem = {};
    Object.keys(headers).forEach(key => {
      transformedItem[key] = item[key] || ''; // Default to empty string if null/undefined
    });
    return transformedItem;
  });
};
